import React, { createContext, useContext } from "react";
import {
  mapOrganization,
  mapOrganizationCONTENT,
} from "../../../constants/map/organization";
import useOrganizationQueries from "../../../customHooks/useOrganizationQueries";

const OrganizationContext = createContext();

const OrganizationProvider = (props) => {
  const { children } = props;
  const {
    organization,
    organizationMember,
    organizationContent,
    deleteAnOrganization,
    uploadAnOrganizationFile,
    updateAnOrganization,
    acceptAnOrganizationInvitation,
    updateAnOrganizationMembership,
    deleteAnOrganizationAsInvited,
    deleteAnOrganizationDocument,
    state,
  } = useOrganizationQueries();
  const {
    fieldDocuments,
    roles,
    organizationMembers,
    organizationApplications,
  } = state;

  const loading =
    organization.isLoading ||
    organizationMember.isLoading ||
    deleteAnOrganization.isLoading ||
    uploadAnOrganizationFile.isLoading ||
    updateAnOrganization.isLoading ||
    acceptAnOrganizationInvitation.isLoading ||
    updateAnOrganizationMembership.isLoading ||
    deleteAnOrganizationAsInvited.isLoading ||
    deleteAnOrganizationDocument.isLoading;

  const value = {
    organizationData: mapOrganization(organization?.data), // Pass data from React Query
    organizationMembers: Object.values(organizationMembers),
    organizationContentData: organizationApplications
      ? mapOrganizationCONTENT({ payload: { data: organizationApplications } })
      : mapOrganizationCONTENT(organizationContent?.data),
    loading: loading,
    deleteOrganization: deleteAnOrganization,
    uploadOrganizationFile: uploadAnOrganizationFile,
    updateOrganization: updateAnOrganization,
    roles: roles,
    documents: fieldDocuments,
    acceptOrganizationInvitation: acceptAnOrganizationInvitation,
    updateOrganizationMembership: updateAnOrganizationMembership,
    deleteAnOrganizationAsInvited,
    deleteOrganizationDocument: deleteAnOrganizationDocument,
  };

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
};

const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (context === undefined) {
    throw new Error(
      "useOrganizationQueries must be used within an OrganizationProvider"
    );
  }
  return context;
};

export { OrganizationProvider, useOrganization };
